import { intl } from '@approvalmax/utils';
import { FC, memo } from 'react';

import { useCurrencyPrecision } from '../../hooks';
import { messages } from './AmountInfoExpenseReport.messages';
import { BlockLabel, BlockLine, BlockValue, Main, Separator } from './AmountInfoExpenseReport.styles';
import { AmountInfoExpenseReportProps } from './AmountInfoExpenseReport.types';

export const AmountInfoExpenseReport: FC<AmountInfoExpenseReportProps> = memo((props) => {
    const { currency, totalExpenses, advance, reimbursableAmount, qa } = props;

    const currencyPrecision = useCurrencyPrecision(currency);

    const currencyName = currency?.text ?? '';

    return (
        <Main>
            <BlockLine data-qa={qa?.('total-expenses')}>
                <BlockLabel data-qa={qa?.('total-expenses-label')}>{messages.totalExpenses}</BlockLabel>

                <BlockValue data-qa={qa?.('total-expenses-value')}>
                    {intl.formatCurrency(totalExpenses, currencyName, currencyPrecision, false)}
                </BlockValue>
            </BlockLine>

            <BlockLine data-qa={qa?.('advance')}>
                <BlockLabel data-qa={qa?.('advance-label')}>{messages.advance}</BlockLabel>

                <BlockValue data-qa={qa?.('advance-value')}>
                    {intl.formatCurrency(advance, currencyName, currencyPrecision, false)}
                </BlockValue>
            </BlockLine>

            <BlockLine>
                <Separator />
            </BlockLine>

            <BlockLine data-qa={qa?.('reimbursable-amount')}>
                <BlockLabel data-qa={qa?.('reimbursable-amount-label')}>{messages.reimbursableAmount}</BlockLabel>

                <BlockValue data-qa={qa?.('reimbursable-amount-value')}>
                    {intl.formatCurrency(reimbursableAmount, currencyName, currencyPrecision, false)}
                </BlockValue>
            </BlockLine>
        </Main>
    );
});

AmountInfoExpenseReport.displayName = 'AmountInfoExpenseReport';
